/*
 * @Author: your name
 * @Date: 2021-06-02 19:22:02
 * @LastEditTime: 2021-06-18 16:55:57
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /burgeon-project-logic/js/modal/orderCenter/returngood/modifyReturnLogistics.js
 */
export default {
  props: {
    componentData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      formConfig: {
        formValue: {
          CP_C_LOGISTICS_ENAME: '',
          CP_C_LOGISTICS_ID: ''
        },
        formData: [{
          style: 'dropSelect',
          width: '24',
          // version: '1.3',
          itemdata: {
            colid: 168212,
            colname: 'CP_C_LOGISTICS_ID', // 当前字段的名称
            display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
            fkdisplay: 'drp', // 外键关联类型
            fkdesc: '实体仓档案',
            inputname: 'CP_C_LOGISTICS_ID:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
            isfk: true, // 是否有fk键
            isnotnull: true, // 是否必填
            isuppercase: false, // 是否转大写
            name: t('物流公司'), // t('入库实体仓库')
            readonly: false, // 是否可编辑，对应input   readonly属性
            pid: '',
            valuedata: '' // 这个是选择的值
          },
          oneObj: (e) => {
            console.log(e);
            this.formConfig.formValue.CP_C_LOGISTICS_ID = e.pid
            this.formConfig.formValue.CP_C_LOGISTICS_ENAME = e.valuedata
          }
        },
        ]
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            type: '', // 按钮类型
            text: t('取消'),
            icon: '', // 按钮图标
            size: 'small', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          },
          {
            type: 'primary', // 按钮类型
            text: t('确定'),
            icon: '', // 按钮图标
            size: 'small', // 按钮大小
            disabled: false, // 按钮禁用控制
            btnclick: () => {
              this.confirm();
            } // 按钮点击事件
          }
        ]
      }
    }
  },
  mounted() {
    console.log(this.componentData.row);
  },
  methods: {
    async confirm() {
      let self = this;
      if (!self.formConfig.formData[0].itemdata.pid) {
        $utils.msgTips(self, 'warning', t('物流公司不能为空!'), 0)
        return;
      }
      const { CP_C_LOGISTICS_ID, CP_C_LOGISTICS_ENAME } = this.formConfig.formValue
      const params = {
        objid: this.componentData.row.ID,
        OcBreturnOrder: {
          CP_C_LOGISTICS_ID,
          CP_C_LOGISTICS_ENAME
        }
      }
      const { data: { code, message }} = await this.service.common.returnOrder(params)
      if (code == 0) {
        $utils.msgTips(self, 'success', message, 0);
        this.$parent.$parent.$parent.getList(this.$parent.$parent.$parent.statusTab);
      } else {
        $utils.msgTips(self, 'error', message, 0);
      }
      this.$parent.$parent.closeConfirm();
    }
  }
}
